import { FC } from 'react';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { Box, Heading, Text } from '@wix/design-system';
import Star from '@components/Images/Star';
import { ReviewsMainHeaderProps } from '@components/Reviews/types';
import s from './ReviewsHeader.module.scss';

const ReviewsHeader: FC<ReviewsMainHeaderProps> = ({
  isMobileView,
  reviewsCount,
  averageReviewRating,
  showReviewsCount = true,
  title,
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  return (
    <Box direction="vertical" marginBottom={isMobileView ? 'SP4' : 'SP1'}>
      {showReviewsCount && (
        <Heading
          size={isMobileView ? 'medium' : 'large'}
          as="h2"
          dataHook="reviews-title"
          id="reviews-title"
          tabIndex={-1}
        >
          {t(title)}
          {reviewsCount > 0
            ? ` (${Intl.NumberFormat(language, {}).format(reviewsCount)})`
            : ''}
        </Heading>
      )}

      {reviewsCount > 0 && (
        <Box marginTop="SP3">
          <Box verticalAlign="middle" marginRight="SP1">
            <Star
              className={isMobileView ? s.reviewStarMobile : s.reviewStar}
            />
          </Box>
          <Box verticalAlign="bottom">
            <Heading size={isMobileView ? 'large' : 'extraLarge'} as="span">
              {Intl.NumberFormat(language, {
                maximumFractionDigits: 1,
                minimumFractionDigits: 1,
              }).format(averageReviewRating)}
            </Heading>
            <Box paddingBottom={isMobileView ? '0' : '4px'}>
              <Text className={s.textColor}>&nbsp;/&nbsp;5</Text>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default ReviewsHeader;
